import React from "react";
import styled from "styled-components";
import { DatePicker, ConfigProvider } from "antd";
import { DatePicker as DatePickerJalali, Calendar } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import colors from "constants/palette";

const Container = styled.div`
  margin-top: 12px;
  & .ant-picker {
    background-color: ${colors.white + "40"} !important;
    color: ${colors.dark};
  }
  & .ant-picker-input,
  .anticon,
  input {
    color: ${colors.dark};
  }

  & .ant-picker-clear .anticon {
    color: ${colors.dark};
  }
  & .ant-picker-clear {
    background-color: ${colors.white} !important;
    border-radius: 12px;
  }
  /* dateinput */
  & .ant-picker-input input::placeholder {
    color: ${colors.dark + "9c"};
  }
`;

export default function App(props) {
  return (
    <Container>
      <ConfigProvider locale={fa_IR} direction="rtl">
        <DatePickerJalali {...props} />
      </ConfigProvider>
    </Container>
  );
}
